'use client'

import { useContext } from 'react'

import {
  FirstAvailableDeliverySlots,
  FirstAvailableDeliverySlotsContext
} from '../providers/DeliverySelectionProvider'

export const useFirstAvailableDeliverySlots = (): FirstAvailableDeliverySlots =>
  useContext(FirstAvailableDeliverySlotsContext) as FirstAvailableDeliverySlots
